const READY_ITEM_STATUSES = new Set([
    "Completed",
    "Delivering",
    "Delivered",
    "Invoiced",
]);
const DELIVERED_ITEM_STATUSES = new Set(["Delivered", "Invoiced"]);

const visibleOrderItems = (order) =>
    (order?.entry_items || []).filter(
        (item) => !item?.parent_item || item.parent_item === "NULL"
    );

export const isOrderDelivered = (order) => {
    const items = visibleOrderItems(order);
    return (
        items.length > 0 &&
        items.every((item) => DELIVERED_ITEM_STATUSES.has(item?.status))
    );
};

export const isOrderReady = (order) => {
    if (order?.food_ready_time) return true;
    const items = visibleOrderItems(order);
    return (
        items.length > 0 &&
        items.every((item) => READY_ITEM_STATUSES.has(item?.status))
    );
};

export const getExpectedReadyAt = (order, defaultMinutes = 15) => {
    if (!order?.creation) return null;
    const createdAt = new Date(String(order.creation).replace(" ", "T"));
    if (Number.isNaN(createdAt.getTime())) return null;
    const requestedMinutes = Number(order.estimated_preparation_time);
    const minutes =
        Number.isFinite(requestedMinutes) && requestedMinutes > 0
            ? requestedMinutes
            : defaultMinutes;
    return new Date(createdAt.getTime() + minutes * 60 * 1000);
};

export const getCustomerOrderNumber = (order) => {
    const designatedNumber = String(order?.designated_number || "").trim();
    if (designatedNumber) return designatedNumber;
    const name = String(order?.name || "");
    return name.split("-").filter(Boolean).pop() || name;
};
